import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import {
	FormFieldHelpers as Form,
	animateLoop,
	cssUnit,
} from '../../../helpers';
import jobsActions from '../../../actions/jobs/jobs';
import commonActions from '../../../actions/common/search';
import { siteOfOriginHelper } from './../../../helpers/genericHelpers';

class SearchForm extends Component {
	constructor() {
		super();
		this.state = {
			isPopperOpen: false,
			isAdvancedOpen: false,
			searchName: '',
		};

		this.rootElement = React.createRef();
	}

	componentDidMount() {
		document.addEventListener('scroll', this.handleScroll);
		let siteOrigin = siteOfOriginHelper();
		if (siteOrigin !== 'gb') {
			this.toggleCountry(siteOrigin === 'us' ? 233 : 251);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (
			!!this.props.selectedJobCountry &&
			this.props.selectedJobCountry !== nextProps.selectedJobCountry
		) {
			this.props.resetLocation();
		}
	}

	toggleCountry(countryId) {
		this.props.resetLocation();
		this.props.toggleCountry(countryId);
	}

	countryOpts(advanced, currentCountry) {
		return advanced.locations.map(country => (
			<li key={country.id} className="member-country-item">
				<Field
					type="radio"
					value={country.id}
					id={country.id}
					name="country_id"
					checked={country.id === currentCountry.id}
					onClick={countryId => this.toggleCountry(country.id)}
					component={Form.radioField}
					label={country.name}
					labelId={country.id}
				/>
			</li>
		));
	}

	advancedMemberOptions(advanced) {
		const currentCountry = !advanced.locations
			? ''
			: advanced.locations.filter(
					location => location.id === this.props.selectedCountry
			  )[0];
		return (
			<div className="theme-advanced-wrapper collapse" id="advanced">
				<ul className="col-12 member-country-list">
					{!currentCountry ? '' : this.countryOpts(advanced, currentCountry)}
				</ul>
				<div className="col-12 form-group">
					<Field
						name="region_id"
						format={null}
						placeholder={`Select ${
							this.props.selectedCountry === 77 ? 'Region' : 'State'
						}`}
						ref="locations"
						multi={true}
						component={Form.selectField}
						options={
							!currentCountry
								? undefined
								: currentCountry.regions.map(region => ({
										value: region.id,
										label: region.name,
								  }))
						}
					/>
				</div>
				<div className="col-12 form-group">
					<Field
						name="industry_id"
						placeholder="Select Industry"
						multi={true}
						component={Form.selectField}
						options={
							!advanced.industries
								? undefined
								: advanced.industries.map(industry => ({
										value: industry.id,
										label: industry.name,
								  }))
						}
					/>
				</div>
			</div>
		);
	}

	render() {
		const expertise = () =>
			!this.props.advanced.expertise
				? undefined
				: this.props.advanced.expertise.map(field => ({
						value: field.id,
						label: field.name,
				  }));

		// search filter BG image
		const image = '/images/members-page.jpg';
		return (
			<form
				onSubmit={this.props.handleSubmit}
				ref={this.rootElement}
				className="container-fluid theme-search-form"
			>
				<div
					className="image"
					style={{ backgroundImage: `url(${image})` }}
				></div>
				<div className="container">
					<div className="row">
						<div className="col-12 col-lg-10 col-xl-7 col-xxl-5">
							<div className="col-12">
								<h1 className="heading-main">
									{this.props.membersInfo &&
										this.props.membersInfo.member_title}
								</h1>
							</div>
							<div className="col-12 advanced-option member">
								<button
									type="button"
									className="theme-helper-button collapsed"
									data-toggle="collapse"
									data-target="#advanced"
									aria-expanded="false"
									aria-controls="advanced"
									onClick={() => this.setState}
								>
									Advanced
									<i
										className={`fa fa-right ${
											this.state.isAdvancedOpen
												? 'fa-angle-up'
												: 'fa-angle-down'
										} button-icon`}
									/>
								</button>
							</div>
							<div className="col-12 form-group">
								<Field
									className="search-form__field"
									name="keyword"
									placeholder="Enter keyword..."
									component={Form.textField}
								/>
							</div>

							<div className="col-12 form-group">
								<Field
									name="expertise_id"
									placeholder="Select Expertise"
									multi={true}
									component={Form.selectField}
									options={expertise()}
								/>
							</div>

							{this.advancedMemberOptions(this.props.advanced)}

							<div className="col-12 form-button">
								<button type="submit" className="theme-button">
									Search
								</button>
								<button
									type="button"
									onClick={this.props.clearForm}
									className="clickable"
								>
									Clear Search
								</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		);
	}
}

SearchForm = reduxForm({ form: 'search_form' })(SearchForm);
const valueSelector = formValueSelector('search_form');

const mapStateToProps = state => ({
	selectedCountry: state.search.selectedCountry,
	selectedJobCountry: valueSelector(state, 'country_id'),
	selectedRegion: valueSelector(state, 'region_id'),
	selectedIndustry: valueSelector(state, 'industry'),
	selectedExpertise: valueSelector(state, 'expertise'),
	selectedRemunerationType: valueSelector(state, 'remuneration_type_id'),
	formValues: state.form.search_form,
	initialValues: state.common.initialValues,
	jobOptions: state.jobs.options,
});

const mapDispatchToProps = dispatch => ({
	getJobLocations: () => dispatch(jobsActions.getJobLocations()),
	toggleCountry: countryId => dispatch(commonActions.toggleCountry(countryId)),
	resetLocation: () => dispatch(change('search_form', 'region_id', null)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SearchForm);



// WEBPACK FOOTER //
// src/client/components/common/search/SearchForm.js